import styled from "styled-components";

export const Sidebar = styled.aside`
  width: 280px;
  background: #ffffff;
  border-right: 1px solid #e0e0e0;
  display: flex;
  flex-direction: column;

  @media (max-width: 768px) {
    width: 100%;
    height: 240px;
  }
`;

export const SidebarHeader = styled.h2`
  font-size: 1rem;
  padding: 16px;
  margin: 0;
  border-bottom: 1px solid #e0e0e0;
`;

export const ChatList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  overflow-y: auto;
  flex: 1;
`;

export const ChatListItem = styled.li`
  padding: 12px 16px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  background: ${({ active }) => (active ? "#eef7ff" : "transparent")};
  border-left: ${({ active }) => (active ? "4px solid #2196f3" : "4px solid transparent")};

  &:hover {
    background: #f0f0f0;
  }
`;

export const LastText = styled.span`
  font-size: 0.85rem;
  color: #555;
  margin-top: 4px;
`;

export const UnreadDot = styled.span`
  display: inline-block;
  width: 8px;
  height: 8px;
  background: #ff3d00;
  border-radius: 50%;
  margin-left: 8px;
`;